import Reflux from 'reflux'
import Store from '../store/store'

class BaseComponent extends Reflux.Component {

    constructor(props) {
        super(props)
        this.store = Store
    }

    render() {
        return null
    }
}

export default BaseComponent


// WEBPACK FOOTER //
// ./src/components/base.js